var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"market-rules"},[_c('div',{attrs:{"id":"market-rules"}}),_vm._v(" "),_c('div',{class:_vm.marginBoxClass},[_c('div',{ref:"wrap",class:_vm.wrapperClass},[_c('market-rules-content',{ref:"content",attrs:{"market":_vm.market}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c2f909f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/market/market-rules/market-rules.vue
// module id = qZUk
// module chunks = 0